import React from "react";
import IntegrationDetail from "./IntegrationDetail";

const IntegrationSTOEngine = () => <IntegrationDetail integrationKey="sto_engine" />;

export default IntegrationSTOEngine;
